import httpRequest from 'httpRequest'
import { LocationOrderFulfillmentTypeContract } from 'models'

const LOCATION_ORDER_FULFILLMENT_PREFIX = '/location/order-fulfillment'
const LOCATIONS_ORDER_FULFILLMENT_PREFIX = (locationId: string) =>
    `/locations/${locationId}/order-fulfillment`

const orderFulfillmentService = {
    updateLocationOrderFulfillments: (
        fulfillments: LocationOrderFulfillmentTypeContract[],
    ) => httpRequest.put(LOCATION_ORDER_FULFILLMENT_PREFIX, fulfillments),

    getLocationOrderFulfillment() {
        return httpRequest.get<LocationOrderFulfillmentTypeContract[]>(
            LOCATION_ORDER_FULFILLMENT_PREFIX,
        )
    },
    getOrderFulfillmentByLocationId: (locationId: string) =>
        httpRequest.get<LocationOrderFulfillmentTypeContract[]>(
            LOCATIONS_ORDER_FULFILLMENT_PREFIX(locationId),
        ),
}

export default orderFulfillmentService
